import { render, staticRenderFns } from "./ClientsIcon.vue?vue&type=template&id=5c168193"
import script from "./ClientsIcon.vue?vue&type=script&lang=js"
export * from "./ClientsIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports